import {
    actionLoading,
    actionSuccess,
    actionErrored,
    actionReset,
} from 'api/helpers'
import { unAuthRequest } from 'api/helpers'
import URL from 'api/endpoints'

// Fetch issues list
export const GET_ISSUES_LIST = 'GET_ISSUES_LIST'
export const GET_MORE_ISSUES = 'GET_MORE_ISSUES'

export const getIssuesListLoading = actionLoading(GET_ISSUES_LIST)
export const getIssuesListSuccess = actionSuccess(GET_ISSUES_LIST)
export const getIssuesListErrored = actionErrored(GET_ISSUES_LIST)
export const getIssuesListReset = actionReset(GET_ISSUES_LIST)

export const getMoreIssuesSuccess = actionSuccess(GET_MORE_ISSUES)

export const getIssuesList = (params = '') => {
    return (dispatch) =>
        unAuthRequest.get(
            dispatch,
            URL.issues + params,
            getIssuesListLoading,
            getIssuesListSuccess,
            getIssuesListErrored
        )
}

export const getMoreIssues = (params = '') => {
    return (dispatch) =>
        unAuthRequest.get(
            dispatch,
            URL.issues + params,
            getIssuesListLoading,
            getMoreIssuesSuccess,
            getIssuesListErrored
        )
}

export const resetGetIssuesListState = () => {
    return function (dispatch) {
        dispatch(getIssuesListReset())
    }
}

// filter issues
export const FILTER_ISSUES = 'FILTER_ISSUES'

export const filterIssuesLoading = actionLoading(FILTER_ISSUES)
export const filterIssuesSuccess = actionSuccess(FILTER_ISSUES)
export const filterIssuesErrored = actionErrored(FILTER_ISSUES)

export const filterIssues = (params = '') => {
    return (dispatch) =>
        unAuthRequest.get(
            dispatch,
            URL.issues + params,
            filterIssuesLoading,
            filterIssuesSuccess,
            null
        )
}

// fetch issues stats
export const GET_ISSUES_STATS = 'GET_ISSUES_STATS'

export const getIssuesStatsLoading = actionLoading(GET_ISSUES_STATS)
export const getIssuesStatsSuccess = actionSuccess(GET_ISSUES_STATS)
export const getIssuesStatsErrored = actionErrored(GET_ISSUES_STATS)

export const getIssuesStats = (params = '') => {
    return (dispatch) =>
        unAuthRequest.get(
            dispatch,
            URL.issueStats + params,
            getIssuesStatsLoading,
            getIssuesStatsSuccess,
            getIssuesStatsErrored
        )
}
